export const bgTypes = [
	{ label: 'Solid', value: 'solid' },
	{ label: 'Gradient', value: 'gradient' },
	{ label: 'Image', value: 'image' },
];

export const attachments = [
	{ label: 'Default', value: '' },
	{ label: 'Initial', value: 'initial' },
	{ label: 'Scroll', value: 'scroll' },
	{ label: 'Fixed', value: 'fixed' },
	{ label: 'Local', value: 'local' },
];

export const repeats = [
	{ label: 'Default', value: '' },
	{ label: 'No Repeat', value: 'no-repeat' },
	{ label: 'Repeat', value: 'repeat' },
	{ label: 'Repeat X', value: 'repeat-x' },
	{ label: 'Repeat Y', value: 'repeat-y' },
];

export const sizes = [
	{ label: 'Default', value: '' },
	{ label: 'Cover', value: 'cover' },
	{ label: 'Auto', value: 'auto' },
	{ label: 'Contain', value: 'contain' },
];